import React, { useState } from "react";
import { useApp } from "context";
import { Custom, DateTime } from "components";
import { IAppointment } from "interfaces";

type Props = {
  opened?: boolean;
  toggle?: () => void;
  selectedHealth360?: IAppointment | null;
};

export const BigCalendar = (props: Props) => {
  const { t, theme } = useApp();

  const [refresh, setRefresh] = useState(0);
  const action = (
    <Custom.Button
      size="small"
      variant="outlined"
      onClick={() => setRefresh(refresh + 1)}
    >
      Refresh
    </Custom.Button>
  );

  return (
    <Custom.Card
      title="Calendar"
      opened={props.opened}
      toggle={props.toggle}
      action={action}
    >
      <DateTime.BigCalendar
        opened={props.opened}
        selectedHealth360={props.selectedHealth360}
        refresh={refresh}
      />
    </Custom.Card>
  );
};
